import { defineMessages } from 'react-intl';

const messages = defineMessages({
  previewLink: {
    description: 'Preview Link',
    defaultMessage: 'Preview Link',
    id: 'SAEl2o',
  },
});

export default messages;
